import type { NotRecognizedConciliation } from 'lib/types/models';

import type {
  DocumentWithConciliation,
  PayInWithDetails,
} from './payInReportGenerator';
import { PayInReportGenerator } from './payInReportGenerator';
import type { PayInExportConfig } from './types';

export type { PDFGeneratorConfig } from '../reportUtils/base';
export { BasePDFGenerator } from '../reportUtils/base';
export * from '../reportUtils/documentUtils';
export { default as PayInExportDialog } from './components/PayInExportDialog';
export type {
  DocumentWithConciliation,
  PayInBusiness,
  PayInStakeholder,
  PayInWithDetails,
  ProductType,
} from './payInReportGenerator';
export { PayInReportGenerator } from './payInReportGenerator';
export type { PayInExportConfig } from './types';

export const generatePayInReportPDF = async (
  payIn: PayInWithDetails,
  documents: DocumentWithConciliation[],
  fncConciliations: NotRecognizedConciliation[],
  userName: string,
  imageBase64: string,
  exportConfig?: PayInExportConfig,
) => {
  const generator = new PayInReportGenerator({
    userName,
    imageBase64,
    title: 'Detalle Conciliaciones Pago',
    fileName: `REPORTE-CONCILIACIONES-PAGO-${payIn.businessOriginName}.pdf`,
    payIn,
    documents,
    fncConciliations,
    exportConfig,
  });
  await generator.generate();
};
